import { FC } from 'react';
import Image from 'next/image';
import { Age, ListInformation, ListItem } from './DetailInformation.style';
interface Props {
  brand: string;
  brandLogo?: string;
  category: string;
  weight: string;
  amount: string;
  meatType: string;
  allergen: string;
  beforeOpen: string;
  afterOpen: string;
  FDAnumber: string;
}
const DetailInformation: FC<Props> = ({
  brand,
  brandLogo,
  category,
  weight,
  amount,
  meatType,
  allergen,
  beforeOpen,
  afterOpen,
  FDAnumber
}: Props) => {
  return <>
            {brand && <ListInformation>
                    <span>ยี่ห้อ</span>
                    <ListItem>
                        <p>
                            {brand}
                            {brandLogo && <Image src={brandLogo} alt="BrandLogo" width={24} height={24} />}
                        </p>
                    </ListItem>
                </ListInformation>}
            {category && <ListInformation>
                    <span>หมวดหมู่</span>
                    <p>{category}</p>
                </ListInformation>}
            {weight && <ListInformation>
                    <span>น้ำหนักสุทธิ</span>
                    <p>{weight}</p>
                </ListInformation>}
            {amount && <ListInformation>
                    <span>จำนวนสินค้า</span>
                    <p>{amount}</p>
                </ListInformation>}
            {meatType && <ListInformation>
                    <span>ประเภทเนื้อสัตว์</span>
                    <p> {meatType}</p>
                </ListInformation>}
            {allergen && <ListInformation>
                    <span>สารก่อภูมิแพ้</span>
                    <p>{allergen}</p>
                </ListInformation>}
            {beforeOpen && <ListInformation>
                    <Age>
                        <span>อายุสินค้า</span>
                        <p>(ก่อนเปิดบรรจุภัณฑ์)</p>
                    </Age>
                    <p>{beforeOpen}</p>
                </ListInformation>}
            {afterOpen && <ListInformation>
                    <Age>
                        <span>อายุสินค้า</span>
                        <p>(หลังเปิดบรรจุภัณฑ์)</p>
                    </Age>
                    <p>{afterOpen}</p>
                </ListInformation>}
            {FDAnumber && <ListInformation>
                    <span>หมายเลข อย.</span>
                    <p>{FDAnumber}</p>
                </ListInformation>}
        </>;
};
export default DetailInformation;